import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Menu, Checkbox, Row, Col } from 'antd';
import './tag.less'; // Import the CSS file
import { useDispatch } from 'react-redux';
import { updateDropdownSearchFilter } from '../../../store/actions/inPatientAction';
import { ALL_DATE_FILTERS, DATE_FILTER, DEFAULT_DATE_FILTER } from '../../constants/commonConstants';

// Define types for the filter options
interface FilterOption {
  value: string;
  label: string;
}

interface FilterDropdownProps {
  filters: FilterOption[];
  onChange: (selectedFilters: string[]) => void;
  component: any;
  selectedDropdownFilters?: string[];
}

const FilterDropdown: React.FC<FilterDropdownProps> = (props: FilterDropdownProps): JSX.Element => {
  const { filters, onChange, component, selectedDropdownFilters = [] } = props;

  const [selectedFilters, setSelectedFilters] = useState<string[]>(selectedDropdownFilters);
  const [isDateDropDownOpen, setIsDateDropDownOpen] = useState(false);
  const dropDownRef = useRef<HTMLDivElement>(null);

useEffect((): void => {
  if (selectedDropdownFilters?.length !== 0) {
    setSelectedFilters(selectedDropdownFilters);
  }
  }, [selectedDropdownFilters]);

  // Handle checkbox change
  const handleCheckboxChange = (filter: string): void => {
    let newSelectedFilters: string[];

    if (filter === DEFAULT_DATE_FILTER[0]) {
      newSelectedFilters = DEFAULT_DATE_FILTER;
      setIsDateDropDownOpen(false); // Close dropdown if selected  "All Dates"
    } else {
      newSelectedFilters = selectedFilters?.includes(filter)
        ? selectedFilters?.filter((item: any): any => item !== filter)
        : [
            ...selectedFilters?.filter((item: any): any => item !== DEFAULT_DATE_FILTER?.[0]),
            filter,
          ];

      if (ALL_DATE_FILTERS?.every((item: any): any => newSelectedFilters?.includes(item))) {
        newSelectedFilters = DEFAULT_DATE_FILTER;
        setIsDateDropDownOpen(false); // Close dropdown if "All Dates" is selected
      }
    }

    setSelectedFilters(newSelectedFilters);
    dispatch(updateDropdownSearchFilter({ dateFilter: newSelectedFilters }));
    onChange(newSelectedFilters);
  };

  const dispatch = useDispatch();
  // Sync state when opening dropdown to retain selections
  const handleDropdownVisibleChange = (visible: boolean): void => {
    setIsDateDropDownOpen(visible);
    if (!visible) {
      if (selectedFilters?.length === 0) {
        setSelectedFilters(DEFAULT_DATE_FILTER);
        onChange(DEFAULT_DATE_FILTER);
        dispatch(updateDropdownSearchFilter({ [DATE_FILTER]: DEFAULT_DATE_FILTER }));
      } else {
        setSelectedFilters(selectedDropdownFilters);
      }
    }
  };

  const menu = (
    <Menu className="filter-date-dropdown">
      {filters?.map((filter: FilterOption): any => (
        <Menu.Item key={filter?.value}>
          <Row>
            <Col>
              <Checkbox
        className={`${selectedFilters?.includes(filter.value) ? 'custom-checkbox-selected' : 'custom-checkbox-unselected'} customCheckBox`}
        checked={selectedFilters?.includes(filter.value)}
                onChange={(): void => handleCheckboxChange(filter.value)}
              >
                <span className={`${selectedFilters?.includes(filter.value) ? 'custom-checkbox-selected' : ''} dropdownFont`}>
                  {filter?.label}
                </span>
              </Checkbox>
            </Col>
          </Row>
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <div ref={dropDownRef} className="filter-dropdown-container">
      <Dropdown
        overlay={menu}
        visible={isDateDropDownOpen}
        onVisibleChange={handleDropdownVisibleChange}
        getPopupContainer={(): any => dropDownRef.current as HTMLElement}
        trigger={['click']}
      >
        <span className="tpa_date_filter_dropdown" onClick={(): void => setIsDateDropDownOpen(!isDateDropDownOpen)}>{component}</span>
      </Dropdown>
    </div>
  );
};

export default FilterDropdown;
